import { FunctionComponent, useMemo, useRef, useEffect } from "react";
import styles from "./TextField.module.scss";
import { TextField } from "@rmwc/textfield";
import "@rmwc/textfield/styles";

type ownProps = {
  title?: string;
  name?: string;
  className?: string;
  wrapperClassName?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  type?: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  icon?: string;
  trailingIcon?: string;
  onTrailingClick?: () => void;
  errorMsg?: string;
  autocomplete?: string;
  [key: string]: any;
};

// type values: color, date, datetime-local, month, range, ...
// https://rmwc.io/text-fields

const TextFieldComponent: FunctionComponent<ownProps> = (props: ownProps) => {
  const {
    title,
    name,
    className = "",
    wrapperClassName = "",
    label,
    placeholder,
    value,
    type,
    icon,
    trailingIcon,
    errorMsg,
    autocomplete,
    ...restProps
  } = props;
  const inputRef = useRef() as any;
  const lastValueRef = useRef("") as any;

  const invalid = useMemo(() => {
    return !!errorMsg;
  }, [errorMsg]);

  const floatLabel = useMemo(() => {
    return !!value;
  }, [value]);

  useEffect(() => {
    if (!(!!lastValueRef.current && !floatLabel)) {
      inputRef.current.adapter.floatLabel(floatLabel);
    }
  }, [floatLabel]);

  useEffect(() => {
    return () => {
      lastValueRef.current = value;
    };
  }, [value]);

  return (
    <div className={`${styles.TextFieldComponent} ${wrapperClassName}`}>
      {title && <p className="mb-4">{title}</p>}
      <TextField
        foundationRef={inputRef}
        name={name}
        className={className}
        label={label}
        value={value}
        type={type || "text"}
        invalid={invalid}
        placeholder={placeholder}
        icon={icon}
        trailingIcon={
          trailingIcon
            ? {
                icon: trailingIcon,
                tabIndex: 0,
                onClick: () => props.onTrailingClick && props.onTrailingClick(),
              }
            : ""
        }
        onChange={(evt: React.FormEvent<HTMLInputElement>) =>
          props.onChange && props.onChange(evt)
        }
        onBlur={(e) => {
          props.onBlur && props.onBlur(e);
        }}
        onFocus={(e) => {
          props.onFocus && props.onFocus(e);
        }}
        autoComplete={autocomplete}
        {...restProps}
      />
      {<p className={styles.errorMsg}>{invalid && errorMsg ? errorMsg : ""}</p>}
    </div>
  );
};

export { TextFieldComponent, TextFieldComponent as default };
